const ActivityIndex = () => import('./pages/activities')
const Refused = () => import('./components/activities/activities-refused')
const Cashier = () => import('./components/activities/activities-cashier')

const CampaignIndex = () => import('./pages/campaign/index')
const CampaignNew = () => import('./pages/campaign/new')
const CampaignEdit = () => import('./pages/campaign/edit')
const CampaignShow = () => import('./pages/campaign/show')

const SettingsIndex = () => import('./pages/settings')
const SettingsFormLayout = () => import('./components/settings/form-layout')

const InitialLoad = () => import('./pages/initial_load')

const LiquidationRequestsIndex = () => import('./pages/liquidation_requests/index')
const LiquidationRequestsNew = () => import('./pages/liquidation_requests/new')
const LiquidationRequestsList = () => import('./pages/liquidation_requests/list')

const OperationIndex = () => import('./pages/operations/index')
const OperationNew = () => import('./pages/operations/new')

const PayerPaymentIndex = () => import('./pages/payer_payment_notifications')

const ContactIndex = () => import('./pages/contacts')

const ManagerInvoiceslist = () => import('./pages/manager_invoices/index')
const ManagerInvoicesEdit = () => import('./pages/manager_invoices/edit')
const ManagerInvoicesDocs = () => import('./pages/manager_invoices/docs')

const ManagerInvoicesCompletedlist = () => import('./pages/manager_invoices/completed')

const InvoiceWithDocumentslist = () => import('./pages/invoices_with_documents/index')
const InvoiceWithDocumentsEdit = () => import('./pages/invoices_with_documents/edit')
const InvoiceWithDocumentsDocs = () => import('./pages/invoices_with_documents/docs')

const FundsIndex = () => import('./pages/funds/index')
// const FundsNew = () => import('./pages/funds/new')
const FundsFormInfos = () => import('./components/funds/infos')
const FundsListActivities = () => import('./components/funds/activities')
const FundsListPayers = () => import('./components/funds/list-payers')
const FundsEdit = () => import('./pages/funds/edit')

export default [
  {
    path: '/management/activities/:id?',
    component: ActivityIndex,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'activities.index',
        component: Cashier,
        meta: { requiresAuth: true }
      },
      {
        path: 'refused',
        name: 'activities.refused',
        component: Refused,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/management/campaigns',
    name: 'campaigns.index',
    component: CampaignIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/campaigns/new',
    name: 'campaigns.new',
    component: CampaignNew,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/campaigns/edit/:id',
    name: 'campaigns.edit',
    component: CampaignEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/campaigns/show/:id',
    name: 'campaigns.show',
    component: CampaignShow,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/settings',
    component: SettingsIndex,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'settings.index',
        component: SettingsFormLayout,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/management/initial-load',
    component: InitialLoad,
    name: 'initial_load.index',
    meta: { requiresAuth: true }
  },
  {
    path: '/management/liquidation_requests',
    component: LiquidationRequestsIndex,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'liquidation_requests.index',
        component: LiquidationRequestsNew,
        meta: { requiresAuth: true }
      },
      {
        path: 'list',
        name: 'liquidation_requests.list',
        component: LiquidationRequestsList,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/management/operations',
    component: OperationIndex,
    meta: { requiresAuth: true },
    name: 'operations.index'
  },
  {
    path: '/management/operations/new',
    component: OperationNew,
    meta: { requiresAuth: true },
    name: 'operations.new'
  },
  {
    path: '/management/payer_payment_notifications',
    name: 'payer_payment_notifications.index',
    component: PayerPaymentIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/contacts',
    name: 'contacts.index',
    component: ContactIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/manager_invoice/completed',
    name: 'manager_invoices_completed.index',
    component: ManagerInvoicesCompletedlist,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/manager_invoices',
    name: 'manager_invoices.index',
    component: ManagerInvoiceslist,
    meta: { requiresAuth: true }
  },
  {
    path: '/management/manager_invoices/edit/:id',
    component: ManagerInvoicesEdit,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'manager_invoices.edit.docs',
        component: ManagerInvoicesDocs,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/management/invoices_with_documents',
    name: 'payer_invoice_upload.index',
    component: InvoiceWithDocumentslist,
    meta: { requiresAuth: true }
  },
  {
    path: 'edit/:id',
    component: InvoiceWithDocumentsEdit,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'invoice_upload.edit.docs',
        component: InvoiceWithDocumentsDocs,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/management/funds',
    name: 'funds.index',
    component: FundsIndex,
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/funds/new',
  //   component: FundsNew,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'funds.new.infos',
  //       component: FundsFormInfos,
  //       meta: { requiresAuth: true }
  //     }
  //   ]
  // },
  {
    path: '/management/funds/edit/:id',
    component: FundsEdit,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'funds.edit.infos',
        component: FundsFormInfos,
        meta: { requiresAuth: true }
      },
      {
        path: 'activities',
        name: 'funds.edit.activities',
        component: FundsListActivities,
        meta: { requiresAuth: true }
      },
      {
        path: 'payers',
        name: 'funds.edit.payers',
        component: FundsListPayers,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/features/management/routes.js